import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import styles from './auth-forms.css';

const projectSharePath = id => `${window.location.origin}/p/${id}`;

class MyStuffModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            tab: 'mine',
            mine: [],
            pub: [],
            error: '',
            loading: true,
            deletingId: null,
            togglingId: null,
            copiedId: null
        };
        this.handleOpen = this.handleOpen.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleTogglePublic = this.handleTogglePublic.bind(this);
        this.handleCopyLink = this.handleCopyLink.bind(this);
        this.load = this.load.bind(this);
    }
    componentDidMount () {
        if (this.props.isOpen) this.load();
    }
    componentDidUpdate (prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) this.load();
    }
    load () {
        this.setState({loading: true, error: ''});
        Promise.all([
            this.props.loadMine().catch(() => []),
            this.props.loadPublic().catch(() => [])
        ]).then(([mine, pub]) => {
            this.setState({mine: mine || [], pub: pub || [], loading: false});
        });
    }
    handleOpen (id) {
        this.props.onOpenProject(String(id));
        this.props.onClose();
    }
    handleDelete (id, title) {
        if (!this.props.onDeleteProject) return;
        const label = title || `проект #${id}`;
        if (!window.confirm(`Удалить «${label}»?`)) return;
        this.setState({deletingId: id, error: ''});
        this.props.onDeleteProject(id)
            .then(() => {
                this.setState(state => ({
                    mine: state.mine.filter(p => String(p.id) !== String(id)),
                    deletingId: null
                }));
            })
            .catch(err => {
                this.setState({
                    deletingId: null,
                    error: err.message || 'Не удалось удалить'
                });
            });
    }
    handleTogglePublic (project, checked) {
        if (!this.props.onTogglePublic) return;
        this.setState({togglingId: project.id, error: ''});
        this.props.onTogglePublic(project.id, checked)
            .then(meta => {
                this.setState(state => ({
                    togglingId: null,
                    mine: state.mine.map(p => (
                        p.id === project.id ? {...p, isPublic: !!meta.isPublic} : p
                    ))
                }));
            })
            .catch(err => {
                this.setState({
                    togglingId: null,
                    error: err.message || 'Не удалось изменить доступ'
                });
            });
    }
    handleCopyLink (id) {
        const link = projectSharePath(id);
        const done = () => {
            this.setState({copiedId: id});
            setTimeout(() => {
                this.setState(state => (state.copiedId === id ? {copiedId: null} : null));
            }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link).then(done).catch(() => {
                window.prompt('Скопируйте ссылку:', link);
                done();
            });
        } else {
            window.prompt('Скопируйте ссылку:', link);
            done();
        }
    }
    renderList (items, editable) {
        if (!items.length) {
            return <div className={styles.empty}>Пока пусто</div>;
        }
        return (
            <ul className={styles.list}>
                {items.map(p => (
                    <li className={styles.listItem} key={p.id}>
                        <div className={styles.listMain}>
                            <button
                                className={styles.linkButton}
                                type="button"
                                onClick={() => this.handleOpen(p.id)}
                            >
                                {p.title || `Проект ${p.id}`}
                            </button>
                            <div className={styles.listMeta}>
                                #{p.id}
                                {p.owner ? ` · ${p.owner}` : ''}
                            </div>
                            {editable ? (
                                <label className={styles.checkRow}>
                                    <input
                                        checked={!!p.isPublic}
                                        disabled={this.state.togglingId === p.id}
                                        type="checkbox"
                                        onChange={e => this.handleTogglePublic(p, e.target.checked)}
                                    />
                                    <span>Публичный</span>
                                </label>
                            ) : (
                                <div className={styles.listMeta}>
                                    {p.isPublic ? 'публичный' : 'приватный'}
                                </div>
                            )}
                            {(editable ? p.isPublic : true) ? (
                                <div className={styles.shareRow}>
                                    <code className={styles.sharePath}>/p/{p.id}</code>
                                    <button
                                        className={styles.linkButton}
                                        type="button"
                                        onClick={() => this.handleCopyLink(p.id)}
                                    >
                                        {this.state.copiedId === p.id ? 'Скопировано' : 'Копировать ссылку'}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                        {editable ? (
                            <button
                                className={styles.buttonSecondary}
                                disabled={this.state.deletingId === p.id}
                                type="button"
                                onClick={() => this.handleDelete(p.id, p.title)}
                            >
                                {this.state.deletingId === p.id ? '…' : 'Удалить'}
                            </button>
                        ) : null}
                    </li>
                ))}
            </ul>
        );
    }
    render () {
        const {tab, mine, pub, loading, error} = this.state;
        return (
            <ReactModal
                isOpen={this.props.isOpen}
                className={styles.modalWide}
                overlayClassName={styles.overlay}
                onRequestClose={this.props.onClose}
                contentLabel="Мои проекты"
            >
                <h2 className={styles.title}>Проекты</h2>
                <div className={styles.tabs}>
                    <button
                        className={tab === 'mine' ? styles.tabActive : styles.tab}
                        type="button"
                        onClick={() => this.setState({tab: 'mine'})}
                    >
                        Мои
                    </button>
                    <button
                        className={tab === 'public' ? styles.tabActive : styles.tab}
                        type="button"
                        onClick={() => this.setState({tab: 'public'})}
                    >
                        Публичные
                    </button>
                </div>
                {error ? <div className={styles.error}>{error}</div> : null}
                {loading ? <div className={styles.empty}>Загрузка…</div> : null}
                {!loading && tab === 'mine' ? this.renderList(mine, true) : null}
                {!loading && tab === 'public' ? this.renderList(pub, false) : null}
                <div className={styles.row} style={{marginTop: '1rem'}}>
                    <button className={styles.buttonSecondary} type="button" onClick={this.props.onClose}>
                        Закрыть
                    </button>
                </div>
            </ReactModal>
        );
    }
}

MyStuffModal.propTypes = {
    isOpen: PropTypes.bool,
    loadMine: PropTypes.func.isRequired,
    loadPublic: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeleteProject: PropTypes.func,
    onOpenProject: PropTypes.func.isRequired,
    onTogglePublic: PropTypes.func
};

export default MyStuffModal;
